interface Props {
  'aria-label': string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: number) => void;
  disabled?: boolean | undefined;
  /** Readout formatter (e.g. ratio → percent). Defaults to the raw number. */
  format?: ((value: number) => string) | undefined;
}

/** Slider with a live readout — used for RTP, whose ceiling comes from the
 *  backend limits and must never be typed past. */
export function RangeInput({ value, min, max, step, onChange, disabled = false, format, ...rest }: Props) {
  return (
    <div className="flex items-center gap-3">
      <input
        type="range"
        aria-label={rest['aria-label']}
        value={value}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-[var(--co-brand)] disabled:opacity-50"
      />
      <span className="w-14 shrink-0 text-right font-mono text-[12px] text-[var(--co-text)]">
        {format ? format(value) : String(value)}
      </span>
    </div>
  );
}
